import "./style.scss";
import { Box, TextField, IconButton, InputAdornment } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { Logo } from "../../assets/icons";
import useValidation from "../Validation";
import Api from "../../openapi";
import { setNotification } from "../../store/notificationSlice";

export interface IPassword {
  oldPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
}

export default function ChangePassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);
  const [process, setProcess] = useState(false);

  const [userInfo, setUserInfo] = useState<IPassword>({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const setField = (field: string, value: string) => {
    setUserInfo((state) => ({
      ...state,
      [field]: value,
    }));
  };

  const handleLogin = async () => {
    if (validation.error) {
      setValidation((state) => ({ ...state, show: true }));
      return;
    }

    try {
      setProcess(true);
      await Api.AdminUser.updateAdminPassword({
        newPassword: String(userInfo.newPassword),
        oldPassword: String(userInfo.oldPassword),
      });
      dispatch(
        setNotification({
          show: true,
          severity: "success",
          message: "Password changed successfully. You will be redirected to main page.",
        })
      );
      setTimeout(() => {
        navigate("/");
      }, 3000);
    } catch (error: any) {
      setProcess(false);
      dispatch(
        setNotification({
          show: true,
          severity: "error",
          message: error.response?.data?.message || error.message,
        })
      );
    }
    setProcess(false);
  };

  const { validation, setValidation } = useValidation(userInfo);

  return (
    <Box sx={{ padding: ["0 16px", "32px"] }} className="login_wrapper" component="form" noValidate>
      <Box mb={6} sx={{ display: "flex", justifyContent: "center", cursor: "pointer" }} onClick={() => navigate("/")}>
        <Logo />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
        <div className="title">Change Password</div>
        <div className="back" onClick={() => navigate(-1)}>
          Back
        </div>
      </Box>

      <div className="password_container">
        <TextField
          type={showPassword1 ? "text" : "password"}
          className="text-input"
          value={userInfo?.oldPassword}
          placeholder={`Old Password`}
          error={validation?.show && validation.oldPassword?.error}
          helperText={
            validation?.show && validation?.oldPassword?.error ? validation?.oldPassword?.helperText : undefined
          }
          onChange={(e) => setField("oldPassword", e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword1((show) => !show)}
                  onMouseDown={(event) => event.preventDefault()}
                  edge="end"
                >
                  {showPassword1 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className="password_container">
        <TextField
          type={showPassword2 ? "text" : "password"}
          className="text-input"
          value={userInfo?.newPassword}
          placeholder={`New Password`}
          error={validation?.show && validation.newPassword?.error}
          helperText={
            validation?.show && validation?.newPassword?.error ? validation?.newPassword?.helperText : undefined
          }
          onChange={(e) => setField("newPassword", e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword2((show) => !show)}
                  onMouseDown={(event) => event.preventDefault()}
                  edge="end"
                >
                  {showPassword2 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className="password_container">
        <TextField
          type={showPassword3 ? "text" : "password"}
          className="text-input"
          value={userInfo?.confirmPassword}
          placeholder={`Confirm Password`}
          error={validation?.show && validation.confirmPassword?.error}
          helperText={
            validation?.show && validation?.confirmPassword?.error ? validation?.confirmPassword?.helperText : undefined
          }
          onChange={(e) => setField("confirmPassword", e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword3((show) => !show)}
                  onMouseDown={(event) => event.preventDefault()}
                  edge="end"
                >
                  {showPassword3 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className="login-btn">
        <LoadingButton color="primary" loading={process} variant="contained" disableElevation onClick={handleLogin}>
          {process ? <span>&nbsp;</span> : <span>Save</span>}
        </LoadingButton>
      </div>
    </Box>
  );
}
